import { ChangeDetectionStrategy, Component, ElementRef, inject, signal } from '@angular/core';
import {
  ActivitySectionDirective,
  UserActivityClickTrackingDirective,
} from '@core';
import {
  PageHeaderBackSwipeConfig,
  PageHeaderComponent,
} from '@app/components/page-header/page-header.component';
import { RouterLink } from '@angular/router';
import { animate, style, transition, trigger } from '@angular/animations';
import { EventsComponent } from '@app/pages/main-page/more-tab/events/events.component';
import { ShopBeerComponent } from '@app/pages/main-page/more-tab/shop-beer/shop-beer.component';
import { GiftCardComponent } from '@app/pages/main-page/more-tab/gift-card/gift-card.component';
import { ReservationComponent } from '@app/pages/main-page/more-tab/reservation/reservation.component';
import { RewardsComponent } from '@app/pages/main-page/more-tab/rewards/rewards.component';
import { PromosComponent } from '@app/pages/main-page/more-tab/promos/promos.component';
import { GameComponent } from '@app/pages/main-page/more-tab/game/game.component';

type State = 'main' | 'game' | 'events' | 'shop-beer' | 'gift-card' | 'reservations' | 'rewards' | 'promos';

@Component({
  selector: 'app-more-tab',
  templateUrl: './more-tab.component.html',
  styleUrls: ['./more-tab.component.scss'],
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    RouterLink,
    EventsComponent,
    ShopBeerComponent,
    GiftCardComponent,
    ReservationComponent,
    RewardsComponent,
    PromosComponent,
    GameComponent,
  ],
  host: {
    'class': 'page',
  },
  animations: [
    trigger('InOutAnimation', [
      transition(':enter', [
        style({ transform: 'translateX(100%)' }),
        animate('400ms ease-in-out', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('400ms ease-in-out', style({ transform: 'translateX(100%)' })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreTabComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  public readonly state = signal<State>('main');

}
